<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import eventHub from '@/eventHub'
export default {
    name: 'App',
    mounted() {
        eventHub.$on('toast-error', (message) => {
            this.$toast.error(message)
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue